var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 198.36 313",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .st0{fill:#2d2f32}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st0",
    d: "M65.18 17.1L17.1 65.18v67.99l48.08 48.09h67.99l48.09-48.09V65.18L133.18 17.1h-68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st0",
    d: "M116.28 78.66c-5.66.02-10.24 4.6-10.26 10.26v20.52c.01 5.67 4.6 10.26 10.27 10.25 5.66-.01 10.24-4.59 10.25-10.25V88.92c-.02-5.66-4.6-10.24-10.26-10.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st0",
    d: "M58.11 0L0 58.11v82.15l58.11 58.1h82.15l58.11-58.11V58.11L140.25 0H58.11zM188.1 63.78v70.8a3.54 3.54 0 01-.99 2.43l-50.1 50.1c-.64.63-1.5.99-2.39.99H63.75c-.9-.01-1.76-.36-2.39-.99L11.25 137a3.54 3.54 0 01-.99-2.43v-70.8c.01-.91.36-1.78.99-2.43l50.1-50.1c.64-.63 1.5-.99 2.39-.99h70.86c.9.01 1.76.36 2.39.99l50.1 50.1c.65.66 1 1.53 1.01 2.44z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    className: "st0",
    d: "M92 195h19v118H92z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.f60a1231d842fe97c1d13a08fce5b786.svg";
export { ForwardRef as ReactComponent };